export default __webpack_public_path__ + "static/media/video-a.b85326d2.jpg";